import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var TaxForm1099IA = function TaxForm1099IA(_ref) {
  var brand = _ref.brand;
  if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "USA") {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "EkqTdQ",
      defaultMessage: [{
        "type": 0,
        "value": "Para receber um formulário fiscal 1099-K, tem de cumprir "
      }, {
        "children": [{
          "type": 0,
          "value": "determinados limites de vendas"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " na Faire. Após confirmar que cumpre esses limites, pode seguir estes passos para consultar e transferir o formulário fiscal 1099-K:"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return CertainSaleLinkFormatting(chunks);
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "VPbiI1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Para entrega eletrónica:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9JoO7p",
      defaultMessage: [{
        "type": 0,
        "value": "Se optou pela entrega eletrónica, pode encontrar o seu formulário fiscal 1099-K nas "
      }, {
        "children": [{
          "type": 0,
          "value": "Definições de conta"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ", na página "
      }, {
        "children": [{
          "type": 0,
          "value": "Exportação e impostos"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": ", no portal da Faire. O formulário fica disponível assim que estiver pronto, habitualmente antes de 31 de janeiro."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Bnijx1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Para entrega por correio físico:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+2dQY7",
      defaultMessage: [{
        "type": 0,
        "value": "Se tiver solicitado uma cópia física, esta deverá ser entregue até meados de fevereiro. Para evitar atrasos, certifique-se de que os dados de contribuinte e o endereço legal estão atualizados nas definições de "
      }, {
        "children": [{
          "type": 0,
          "value": "Exportação e impostos"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Qdu8Ar",
    defaultMessage: [{
      "type": 0,
      "value": "Não vai receber um formulário 1099-K da Faire porque estes só são enviados a marcas localizadas nos EUA. Se a sua marca estiver localizada nos EUA e considerar que devia ter recebido este formulário, contacte-nos abaixo."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var CertainSaleLinkFormatting = function CertainSaleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360022603552"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};